import { createI18n } from 'vue-i18n'
import en from '../locales/en.js'
import ru from '../locales/ru.js'
import es from '../locales/es.js'
import de from '../locales/de.js'

// Загружаем сохраненный язык из localStorage
const getSavedLanguage = () => {
  try {
    const saved = localStorage.getItem('app_language')
    if (saved && ['en', 'ru', 'es', 'de'].includes(saved)) {
      return saved
    }
  } catch (error) {
    console.error('Error loading language:', error)
  }
  return 'en' // По умолчанию английский
}

const savedLanguage = getSavedLanguage()

const i18n = createI18n({
  legacy: false, // Используем Composition API
  locale: savedLanguage,
  fallbackLocale: 'en',
  messages: {
    en,
    ru,
    es,
    de
  }
})

export default i18n

